//
// NotImplementedWorkspace
//
// Used instead of a yet-to-be-implemented Workspace

import { observer } from 'mobx-react-lite'
import { useStore } from '../stores'

import { HView, Spacer, VView } from '../appview'
import { AboutPanel } from '../panels'

export const NotImplementedWorkspace = observer(
    function NotImplementedWorkspace(props) {
        const store = useStore()
        const app = store.app

        return (
            <VView grow>
                <VView className="worksheet">
                    <HView>
                        <Spacer />
                        <VView className="form">
                            <Spacer size={20} />
                            <AboutPanel
                                version={store.version}
                                message={app.text(
                                    'This workspace is not implemented yet.'
                                )}
                            />
                        </VView>
                        <Spacer />
                    </HView>
                </VView>
            </VView>
        )
    }
)
